import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import actPosition from '~/modules/master/redux/actions/position'

const usePosition = () => {
  const data = useSelector((state) => get(state, 'master.position'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(actPosition, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default usePosition
